import { memo } from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { BAR_WIDTH } from '../../constants';

export const BarChartLoader = memo(() => (
  <Stack direction="row" justifyContent="space-between" width="100%">
    <Stack justifyContent="space-between" pb={4}>
      {Array.from({ length: 6 })
        .fill(null)
        .map((_, index) => (
          <Skeleton key={index} height={16} variant="rounded" width={BAR_WIDTH * 1.5} />
        ))}
    </Stack>
    {Array.from({ length: 5 })
      .fill(null)
      .map((_, index) => (
        <Stack key={index} alignItems="center" gap={2}>
          <Skeleton
            height={200 - index * 40}
            sx={{ marginTop: 'auto' }}
            variant="rectangular"
            width={BAR_WIDTH}
          />
          <Skeleton height={16} variant="rounded" width={BAR_WIDTH * 1.5} />
        </Stack>
      ))}
  </Stack>
));
